// src/components/Billing/BasicHeader.js
// @flow

import React from 'react';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import HeaderTopBar from '../HeaderTopBar';

// If you used to import withStyles, we remove that
// and define style keys inline:

const basicHeaderStyles = {
  appBarFullscreen: (theme) => ({
    position: 'fixed',
    boxShadow: 'none'
  }),
  toolbarRoot: (theme) => ({
    minHeight: theme.layout?.customProps?.toolbar?.height || 56
  }),
  pageTitle: (theme) => ({
    fontSize: '1.8rem',
    fontWeight: 600,
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(0.5),
    color: 'white',
    textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.6rem',
      whiteSpace: 'nowrap',
      overflowX: 'scroll',
      maxWidth: '50vw'
    }
  })
};

type Props = {
  mobileOpen?: boolean,
  title: string,
  mobileTitle?: string,
  usehandleDrawerToggle?: Function
};

const BasicHeader = (props: Props) => {
  const { usehandleDrawerToggle, title, mobileTitle } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Use mobileTitle on small screens if provided, otherwise fall back to title
  const displayTitle = (isMobile && mobileTitle) ? mobileTitle : title;

  return (
    <AppBar
      sx={basicHeaderStyles.appBarFullscreen(theme)}
      position="fixed"
    >
      <Toolbar
        sx={basicHeaderStyles.toolbarRoot(theme)}
        disableGutters
      >
        <Grid container direction="column">
          <HeaderTopBar
            isOnboading
            usehandleDrawerToggle={usehandleDrawerToggle}
          >
            <Typography
              sx={basicHeaderStyles.pageTitle(theme)}
              variant="h2"
            >
              {displayTitle}
            </Typography>
          </HeaderTopBar>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default BasicHeader;